/**
 * Single source of truth for marketing-site pathnames.
 */
export const ROUTES = {
  HOME: '/',
  PRICING: '/pricing',
  BLOGS: '/blogs',
  HELP_CENTER: '/help-center',
  RESOURCES: '/resources',
  CONTACT: '/contact.php',
  ABOUT: '/about.php',
  TRACK_ORDER: '/track-order.php',
  TERMS: '/terms.php',
  /** Reserved for the product app (usually a separate build). Configure edge/nginx before the SPA fallback. */
  APP: '/app',
};

/** Navbar “Resources” group — used for active state. */
export const RESOURCE_NAV_PATHS = [ROUTES.BLOGS, ROUTES.HELP_CENTER, ROUTES.CONTACT];

/**
 * Legacy clean URLs → canonical .php paths for in-app <Navigate />.
 */
export const LEGACY_PHP_REDIRECTS = {
  '/contact': ROUTES.CONTACT,
  '/about': ROUTES.ABOUT,
  '/track-order': ROUTES.TRACK_ORDER,
  '/terms-conditions': ROUTES.TERMS,
};
